import { useQuery } from 'react-query';
import { createFetchAPI } from '../http';

const fetchFavePassDetailsViaMerchantConnect = createFetchAPI<
  FavePassDetailsRequest,
  FavePassDetailsViaMerchantConnectResponse
>();

export const useFetchFavePassDetailsViaMerchantConnect = (
  { fave_passes_id }: FavePassDetailsRequest,
  enabled: boolean,
) =>
  useQuery<FavePassDetailsViaMerchantConnectResponse>(
    ['fetchFavePasses', { url: `v1/mc_products/${fave_passes_id}` }],
    fetchFavePassDetailsViaMerchantConnect,
    { enabled },
  );

type FavePassDetailsRequest = {
  fave_passes_id: string;
};

export type FavePassDetailsViaMerchantConnectResponse = {
  id: string;
  product_type: string;
  product_details: {
    name: string;
    description: string;
    total_sessions: number;
    original_amount: {
      currency: string;
      amount: number;
    };
    discounted_amount: {
      currency: string;
      amount: number;
    };
    fee_percentage: number;
    grabpay_later_fee_percentage: number;
    finance_account_id: string; // bank account
    start_date: string;
    end_date: string;
    reservation_requirement_type: string;
    validity: number;
    what_you_get: string;
    main_category_id: string;
    outlet_ids: string[];
    max_cap: number;
    user_purchase_limit: number;
    cancellation_policy: string;
    image_url: string;
    fine_print: string;
  };
};
